export default __webpack_public_path__ + "static/media/332.312b14ec.jpg";